import Moment from "moment";
import { AuthorizedUser } from "../models/AuthorizedUser";

export class DatetimeFormat {

    private static readonly DateFormat = "DD-MMM-YYYY";
    private static readonly DatetimeFormat = "DD-MMM-YYYY HH:mm";
    private static readonly InvalidDate = "00-00-0000";

    static fixUTCDate(date: any): Date | null {
        if (date) {
            date = new Date(date);
            return new Date(Date.UTC(date.getFullYear(), date.getMonth(), date.getDate(), date.getHours(), date.getMinutes(), date.getSeconds()));
        }
        return null;
    }

    static addTimeZoneOffset(dateWithoutTimeZoneOffset: any, isDateTime: boolean, returnInvalidDate: boolean = false): string | null {
        if (dateWithoutTimeZoneOffset === null) {
            return null;
        }
        if (!this.isValidDateTime(dateWithoutTimeZoneOffset)) {
            return returnInvalidDate ? this.InvalidDate : null;
        }
        let timeZoneOffset = this.calculateTimeZoneOffset(isDateTime);
        let format = isDateTime ? this.DatetimeFormat : this.DateFormat;
        return Moment(dateWithoutTimeZoneOffset).add(timeZoneOffset, "hours").format(format);
    }

    static removeTimeZoneOffset(dateWithTimeZoneOffset: any, isDateTime: boolean, returnInvalidDate: boolean = false): string | null {
        if (dateWithTimeZoneOffset === null) {
            return null;
        }
        if (!this.isValidDateTime(dateWithTimeZoneOffset)) {
            return returnInvalidDate ? this.InvalidDate : null;
        }
        let timeZoneOffset = this.calculateTimeZoneOffset(isDateTime);
        let format = isDateTime ? this.DatetimeFormat : this.DateFormat;
        return Moment(dateWithTimeZoneOffset).subtract(timeZoneOffset, "hours").format(format);
    }

    static zeroUtcOffset(date: any): Date | null {
        if (!this.isValidDateTime(date)) {
            return null;
        }
        return new Date(Moment(date).utcOffset(0, true).format());
    }

    private static calculateTimeZoneOffset(isDateTime: boolean): number {
        if (!isDateTime) {
            return 0;
        }
        let authorizedUserTimeZone = AuthorizedUser.getTimeZone();
        let authorizedUserDaylightSavingTime = AuthorizedUser.getDaylightSavingTime();
        let offset = authorizedUserTimeZone === null ? null : authorizedUserTimeZone.Offset;
        let daylightSavingTime = authorizedUserDaylightSavingTime === null || authorizedUserTimeZone === null || authorizedUserTimeZone?.Code === "UTC" ? false : authorizedUserDaylightSavingTime;
        let daylightSavingTimeOffset = (daylightSavingTime ? 1 : 0);
        if (this.isDefaultTimeZoneOffset(offset)) {
            return daylightSavingTimeOffset;
        }
        if (offset !== null && offset.startsWith("+")) {
            return daylightSavingTimeOffset + Number(offset.split("+")[1]);
        } else if (offset !== null && offset.startsWith("-")) {
            return daylightSavingTimeOffset - Number(offset.split("-")[1]);
        } else {
            return daylightSavingTimeOffset;
        }
    }

    private static isDefaultTimeZoneOffset(offset: any): boolean {
        return offset === null || offset === undefined || offset === "";
    }

    private static isValidDateTime(datetime: any): boolean {
        if (datetime === null || datetime === undefined) {
            return false;
        }
        return Moment(datetime).isValid();
    }
}